export const at_sign = () => (
  <path
    d="M16 8v5a3 3 0 006 0v-1a10 10 0 10-3.92 7.94M16 12a4 4 0 11-8 0 4 4 0 018 0z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
